import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import { NotifyStylePanel } from "@/business/notify/NotifyStylePanel";

/** AI 알림장 — 내 문체 스타일 등록/관리 라우트 (마이페이지 + 알림장 상태카드 공용 진입) */
export const Route = createFileRoute("/business/layout/notify-style")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <LayoutHeader title="내 알림장 스타일" hasBackBtn hasFootPrint={false} />
      <div className="flex-1 min-h-0 flex flex-col bg-[#F5F5F5]">
        <div className="flex-1 min-h-0 overflow-y-auto px-4 pt-3">
          <NotifyStylePanel />
        </div>
      </div>
    </>
  );
}
